import { render, staticRenderFns } from "./FormTransportation.vue?vue&type=template&id=7a94d971"
import script from "./FormTransportation.vue?vue&type=script&lang=js"
export * from "./FormTransportation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports